import type { AssetFromClipboardData } from 'owa-timestream-asset-sdk-types';
import type { FileLinkPayload } from '../schema';
import createOneNoteLinkFromClipboardData from './createOneNoteLinkFromClipboardData';

export default function createFileLinkFromClipboardData(
    getData: (format: string) => string
): AssetFromClipboardData<FileLinkPayload> {
    // Add other known file cases as needed.
    return createOneNoteLinkFromClipboardData(getData);
}
